<div
  class="topic-header d-flex justify-content-between flex-wrap flex-lg-nowrap align-items-center"
>
  <h3 class="topic-title">{{ currentTopic.name }}</h3>
</div>

<div class="topic-description">
  <rich-text [content]="currentTopic.description" />
</div>
